import { render, staticRenderFns } from "./PdfSimpleViewer.vue?vue&type=template&id=01dc53fa&"
import script from "./PdfSimpleViewer.vue?vue&type=script&lang=js&"
export * from "./PdfSimpleViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports